import styled from 'styled-components/macro';
import {
  compose,
  space,
  layout,
  flexbox,
  grid,
  color,
  position,
  typography,
  border,
  shadow,

  // types
  SpaceProps,
  LayoutProps,
  FlexboxProps,
  ColorProps,
  PositionProps,
  TypographyProps,
  BorderProps,
  ShadowProps,
  GridProps,
} from 'styled-system';

type BoxProps = SpaceProps &
  LayoutProps &
  FlexboxProps &
  ColorProps &
  PositionProps &
  TypographyProps &
  BorderProps &
  ShadowProps &
  GridProps;

/**
 * We use the Box component as a generic spacing/layout component throughout the app
 */
const Box = styled.div<BoxProps>`
  ${compose(
    space,
    layout,
    flexbox,
    color,
    position,
    typography,
    border,
    shadow,
    grid
  )} :empty {
    display: none;
  }
`;

export default Box;
